import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isFetching, ResourcesItem, ResourcesReduxState } from 'redux-and-the-rest';
import { UserModel } from './models/userModel';
import { ApplicationState } from './redux/types';

import { getUser, fetchUser } from './redux/reducers/userReducer';
import LoadingIndicator from './components/shared/LoadingIndicator';

interface Props extends React.ComponentProps<'div'> {
   user: ResourcesItem<UserModel>;
   users: ResourcesReduxState<UserModel>;
   children: React.ReactNode;
}

/**
 * Fetches the user session on mount to set the up to date information within the store
 */
const HydrateUser = ({
  children,
  user,
  users,
}: Props) => {
  useEffect(() => {
    fetchUser(users);
  }, []);

  if (isFetching(user)) {
    return <LoadingIndicator />;
  }

  return (
    <>
      {children}
    </>
  );
};

const mapStateToProps = ({ users }: ApplicationState) => {
  const user = getUser(users);

  return {
    user,
    users,
  };
};

export default connect(mapStateToProps)(HydrateUser);
